import * as React from 'react';
import { useSelector } from 'react-redux';
import { AdvantagesMedia } from '../../MarketingPageComponents/AdvantagesMedia';
import { selectMediaBanksNumber } from '../../selectors/media/banksNumber';

export const AdvantagesMediaContainer = () => {
  const banksNumber = useSelector(selectMediaBanksNumber);

  return <AdvantagesMedia banksNumber={banksNumber} />;
};
